import React from 'react';
import './ActiveReceivingHeader.css';
import ReceivingSummary from './ReceivingSummary';

interface SummaryStats {
  preparing: number;
  transit: number;
  completed: number;
  totalPoints: number;
}

interface Props {
  stats?: SummaryStats;
}

export default function ActiveReceivingHeader({ stats }: Props) {
  // Default stats for now
  const defaultStats: SummaryStats = {
    preparing: 189,
    transit: 63,
    completed: 35,
    totalPoints: 756542
  };

  const statsToUse = stats || defaultStats;

  return (
    <div className="active-receiving-header-container">
      <div className="active-receiving-header">
        <h2 className="active-receiving-title">Active Trades</h2>
        <p className="active-receiving-subtitle">
          A summary of your inbound shipments.
        </p>
      </div>
      <ReceivingSummary stats={statsToUse} />
    </div>
  );
}